import { FC } from 'react';

const GuestAuthGuard: FC = ({ children }) => {
  return <>{children}</>;
};

export default GuestAuthGuard;
